<template>
  <div class="user_info_view">
    <div class="user_info_head">
      <div class="deco">
        <h2>사업자 처리 내역</h2>
        <p>사용자 유형을 사업자로 신청하셨거나 사업자의 정보 수정을 신청한 경우 처리상황을 확인할 수 있습니다.</p>
        <div class="bt">
          <v-button @handleClick="handleClick()" :text="buttonText" class="btn10" iconClass="icon_write"></v-button>
        </div>
      </div>
    </div>
    <div class="user_info_body">
      <div class="deco deco_no_padding_side">
        <div class="processing_list">
          <div v-for="(el, idx) of userInfoHistory" :key="idx" class="item" style="padding: 0 30px">
            <dl class="date">
              <dt class="access_hidden">날짜 :</dt>
              <dd>{{ el.reqDate }}</dd>
            </dl>
            <dl class="business">
              <dt class="access_hidden">사업자명 / 사업자번호 :</dt>
              <dd>{{ el.businessName }} / {{ el.businessLicenseNumber }}</dd>
            </dl>
            <dl>
              <dt>유형 :</dt>
              <dd>
                {{ el.businessType == 2 ? '개인 사업자' : '법인 사업자' }}
                {{ businessModifyType(idx, el.applyType) }}
              </dd>
            </dl>
            <dl>
              <dt>대표자명 :</dt>
              <dd>{{ el.businessOwnerName }}</dd>
            </dl>
            <dl>
              <dt>주소 :</dt>
              <dd>({{ el.zipCode }}) {{ el.address1 }} {{ el.address2 }}</dd>
            </dl>
            <dl>
              <dt>계좌정보 :</dt>
              <dd>{{ el.bankName }} / {{ el.accountNo }} (계좌주: {{ el.accountOwnerName }})</dd>
            </dl>
            <dl class="state">
              <dt class="access_hidden">상태</dt>
              <dd v-if="el.status == 0" class="blue">신청</dd>
              <dd v-else-if="el.status == 1" class="blue">처리중</dd>
              <dd v-else-if="el.status == 2" class="blue">승인</dd>
              <dd v-else class="red">반려</dd>
              <dd class="date">(처리일 : {{ el.updateDate }})</dd>
              <dd v-if="el.reason" class="msg">! {{ el.reason }}</dd>
            </dl>
          </div>
          <div class="attention">
            <h4>
              <v-icon clsName="icon_exclamation2" />
              꼭 확인해주세요.
            </h4>
            <p>
              사업자로 신청하시거나, 사업자의 정보를 변경하신 경우 후 필요 서류를 메일로 보내주셔야 합니다.<br />
              보내주신 서류를 검토하여 처리를 해드리며, 승인 이후부터 변경하신 정보로 서비스 이용이 가능합니다.
            </p>
            <dl>
              <dt>필요 서류 :</dt>
              <dd><strong>사업자 등록증 사본 / 통장 사본 / 인감 증명서 / 계좌 확인서</strong></dd>
            </dl>
            <dl>
              <dt>보내실 email :</dt>
              <dd>
                <a href="mailto:rewardpoint_biz@nexon.co.kr">rewardpoint_biz@nexon.co.kr</a>
              </dd>
            </dl>
            <dl style="margin-top: 10px">
              <dt>
                ※ 계좌 확인서는 <a href="/static/account-check.docx" download="계좌확인서.docx">다운로드</a> 받아 작성
                후 인감 날인하여 제출해주세요.<br />
              </dt>
              <dt>※ 인감증명서의 주민등록번호는 마스킹 처리 후 제출해주세요.<br /></dt>
              <dt>
                ※ 인감이 없으신 개인사업자의 경우 계좌 확인서에 자필서명하시고, 자필 서명된 본인서명사실 확인서를 함께
                제출해주세요.<br />
              </dt>
              <dt>
                &nbsp;&nbsp;&nbsp;<a
                  href="https://www.gov.kr/main?a=AA020InfoCappViewApp&HighCtgCD=A01008&CappBizCD=13110000047"
                  target="_blank"
                  >본인서명사실확인서 발급 안내</a
                >
              </dt>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';

export default {
  components: {
    VButton,
    VIcon,
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo', 'userInfoHistory']),
    buttonText() {
      return this.userInfo.businessType === 1 ? '사업자 회원으로 변경' : '사업자 변경 신청';
    },
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('userInfo', ['getBusinessUserInfo']),
    businessModifyType(idx, applyType) {
      if (applyType === 1) {
        return '(사업자 변경)';
      }

      if (applyType === 2) {
        return '(정보 수정)';
      }

      return '';
    },
    handleClick() {
      if (this.userInfo.status !== 0 && this.userInfo.status !== 1) {
        this.$router.replace({ name: 'UserInfoChange' });
      } else {
        this.openModal({
          type: 'alert',
          message: '아직 처리되지 않은 사업자 신청 내역이 있습니다.<br>처리 완료 후 다시 신청이 가능합니다.​',
        });
      }
    },
  },
  async created() {
    await this.getBusinessUserInfo();
  },
};
</script>

<style lang="scss" scoped>
.user_info_view {
  .user_info_body {
    .deco {
      padding: 0;
    }
  }
}
</style>
